import { useTracking } from '@justgiving/react-tracking';
import { useEffect } from 'react';

export interface Props {
  event: string;
  subtype: string;
  page_section: string;
}

export default function usePageViewTracking({
  event,
  subtype,
  page_section,
}: Props) {
  const track = useTracking();

  useEffect(() => {
    track({
      event,
      subtype,
      page_section,
    });
  }, [event, subtype, page_section, track]);
}
